import React from 'react'
import Head from 'next/head'
import QueryString from 'query-string'
import config from 'config'

const IS_PROD = config('NODE_ENV') === 'production'

const SOURCES = [
  'Lifull-Connect',
  'Mitula',
  'Trovit',
  'Thribee',
].map(s => s.toLowerCase())


function referralByTrovit() {
  const currentUrl = window.location.href
  const { query } = QueryString.parseUrl(currentUrl)
  return Boolean(
      query &&
      query.utm_source &&
      SOURCES.includes(query.utm_source.toLowerCase())
    )
}

const Pixel = () => {
  if (IS_PROD) {
    return (
      <Head>
        <script type="text/javascript">
        {`
            (function(i,s,o,g,r,a,m){i['TrovitAnalyticsObject']=r;i[r]=i[r]||function(){
            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','https://analytics.trovit.com/trovit-analytics.js','ta');
            ta('init', 'mx', 1, '2ead46801410ad6159999001254696dc');
            ta('send', 'lead');
            console.log("PIXEL TROVIT rendered")
        `}
        </script>
      </Head>
    )
  }

  return (
    <Head>
      <script type="text/javascript">
        {`
          console.log("PIXEL TROVIT rendered for dev/staging")
        `}
      </script>
    </Head>
  )
}

const EventTrovit= () => {
  if (IS_PROD) {
    return (
      <Head>
        <script type="text/javascript">
        {`
            (function(i,s,o,g,r,a,m){i['TrovitAnalyticsObject']=r;i[r]=i[r]||function(){
            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','https://analytics.trovit.com/trovit-analytics.js','ta');
            ta('send', 'lead');
            console.log("EVENT TROVIT rendered")
        `}
        </script>
      </Head>
    )
  }

  return (
    <Head>
      <script type="text/javascript">
        {`
          console.log("EVENT TROVIT rendered for dev/staging")
        `}
      </script>
    </Head>
  )
}


const Event = () => (referralByTrovit() ? <EventTrovit /> : null)

const PixelTrovit = () => (referralByTrovit() ? <Pixel /> : null)

export {
  PixelTrovit as default,
  Event,
}
